import ReReviewSummary from './ReReviewSummary';

export default ReReviewSummary;
